import script from "./CoordinateValue.vue?vue&type=script&setup=true&lang=js"
export * from "./CoordinateValue.vue?vue&type=script&setup=true&lang=js"

import "./CoordinateValue.vue?vue&type=style&index=0&id=11ea009d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ea009d"]])

export default __exports__